import { useEffect, useState } from 'preact/hooks';
import { engine, type EngineState } from '../engine/engine.js';

/** The engine's state as Preact state. It changes on events (a tap, a status, a setting), never per frame. */
export function useEngineState(): EngineState {
  const [state, setState] = useState(engine.getState());
  useEffect(() => {
    setState(engine.getState());
    return engine.subscribe(setState);
  }, []);
  return state;
}
